.cartSummary {
  display: var(--haus-cartsummary__cartSummary__display, flex);
  flex-direction: var(--haus-cartsummary__cartSummary__flex-direction, column);
  align-items: var(--haus-cartsummary__cartSummary__align-items, flex-start);
  justify-content: var(--haus-cartsummary__cartSummary__justify-content, flex-start);
  gap: var(--haus-cartsummary__cartSummary__gap, 16px);
  width: var(--haus-cartsummary__cartSummary__width, 100%);
}

.error {
  display: var(--haus-cartsummary__error__display, flex);
  justify-content: var(--haus-cartsummary__error__justify-content, center);
  align-items: var(--haus-cartsummary__error__align-items, center);
  padding: var(--haus-cartsummary__error__padding, 1rem);
}
